// Transitions
export const AMC_FORM_VALID_TRANSITION_INCIDENT_DETAILS = "allSureMotorClaim/transition/incidentDetails/formValid";
export const AMC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS = "allSureMotorClaim/transition/incidentDetails/formInvalid";

export const transitionIncidentDetails = {
  formValid: () => ({ type: AMC_FORM_VALID_TRANSITION_INCIDENT_DETAILS }),
  formInvalid: () => ({ type: AMC_FORM_INVALID_TRANSITION_INCIDENT_DETAILS }),
};

// Input felid actions
export const AMC_INCIDENT_DETAILS = "allSureMotorClaim/incidentDetails/";
export const AMC_INCIDENT_DETAILS_SET_VALUE = AMC_INCIDENT_DETAILS+"setValue/";
export const AMC_INCIDENT_DETAILS_SET_VALID = AMC_INCIDENT_DETAILS +"setValid/";


export const setIncidentDetailsValue =(value)=>({type: AMC_INCIDENT_DETAILS_SET_VALUE, value})
export const setIncidentDetailsFieldValid =(error,fieldType)=>({type: AMC_INCIDENT_DETAILS_SET_VALID, error, fieldType})

export const AMC_INCIDENT_DETAILS_SET_VALUE_WITHOUT_VALIDATION = AMC_INCIDENT_DETAILS+"withoutValidation/setValue";
export const setIncidentDetailsWithoutValidation =(value)=>({type: AMC_INCIDENT_DETAILS_SET_VALUE_WITHOUT_VALIDATION, value})
